import type { Favicons } from './favicons';

export const getFavicon = ({
  hostname,
  darkMode,
  favicons,
}: {
  hostname?: string;
  darkMode: boolean;
  favicons: Favicons;
}) => {
  if (hostname === 'studio-staging.apollographql.com') {
    return darkMode ? favicons.staging.dark : favicons.staging.light;
  }
  if (hostname === 'localhost') {
    return darkMode ? favicons.localhost.dark : favicons.localhost.light;
  }
  return darkMode ? favicons.default.dark : favicons.default.light;
};
